import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg.js';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import './globalThis';

import './Accordions';
import './Jump';
import mitt from 'mitt';
import IMask from 'imask';

const WINDOW = window;

const OS_SYSTEMS = [
    ['Win', '-windows'],
    ['Mac', '-macos'],
    ['X11', '-unix'],
    ['Linux', '-linux']
];

for (let index = 0; index < OS_SYSTEMS.length; index++) {
    const item = OS_SYSTEMS[index];
    if (navigator.appVersion.indexOf(item[0]) != -1) {
        document.documentElement.classList.add(item[1]);
        break;
    }
}

window.trackingEvent = (event, data) => {
    if (typeof window.dataLayer != 'object') {
        window.dataLayer = [];
    }
    window.dataLayer.push({ ...data, event });
};

WINDOW.IMask = IMask;
WINDOW.emitter = mitt();

WINDOW.requestAnimationFrame =
    WINDOW.requestAnimationFrame ||
    WINDOW.mozRequestAnimationFrame ||
    WINDOW.webkitRequestAnimationFrame ||
    WINDOW.msRequestAnimationFrame ||
    WINDOW.oRequestAnimationFrame ||
    // IE Fallback
    function(callback) {
        WINDOW.setTimeout(callback, 1000 / 60);
    };
